import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { VeracodeService } from '../../service';

export type VulnerabilityScanningConfig = typeof VulnerabilityScanningConfig._.Config;

export const VulnerabilityScanningConfig = IntegrationConfig.make({
  service: VeracodeService,
  name: Integration_Handler_Names_Enum.VulnerabilityScanning,
  configSchema: z.object({}),
});
